<template>
    <div class="card form-sign-in">
        <div class="card-header">{{t('Forgotten password')}}</div>
        <div class="card-body text-center" v-if="loading === true">
            <loading/>
            <span class="d-block mt-2">{{t('Preparing account to reset password')}}</span>
        </div>
        <div class="card-body text-center" v-if="loading === false && done === true">
            <font-awesome-icon icon="check" size="2x" class="text-success"/>
            <strong class="d-block mt-2">{{t('Account is ready to reset password.')}}</strong>
            <span class="d-block">{{t('Please check your e-mail and follow instructions')}}</span>
        </div>
        <div class="card-body" v-if="loading === false && done === false">
            <titan-form ref="resetPasswordForm"
                        :schema="schema"
                        :renderInCard="false"
                        :model="formData"
                        @saveData="sendForm()"
            />
            <button type="button" class="btn btn-primary btn-block" @click="sendForm()">
                {{t('Reset password')}}
            </button>
        </div>
    </div>
</template>
<script>
    import TitanForm from '../../Form/Form'
    import VueFormGenerator from "vue-form-generator";
    import Loading from '../loading';

    export default {
        components: {
            Loading,
            TitanForm
        },
        props: {
            resetPassword: {
                type: Function,
                required: true,
            }
        },
        methods: {
            sendForm() {
                if (this.$refs.resetPasswordForm.isValid() === true) {
                    this.loading = true;
                    this.resetPassword(this.formData).then(response => {
                        this.loading = false;
                        this.done = true;
                        this.$emit('success');
                    }).catch(error => {
                        this.loading = false;
                        this.$emit('failedToResetPassword', error);
                    });
                }
            },
        },
        data() {
            return {
                loading: false,
                done: false,
                schema: [
                    {
                        name: '',
                        type: 'main',
                        fields: [
                            {
                                type: 'input',
                                inputType: 'text',
                                label: this.t('Login'),
                                model: 'login',
                                required: true,
                                validator: VueFormGenerator.validators.string
                            }
                        ]
                    }
                ],
                formData: {
                    login: '',
                }
            }
        }
    }
</script>
<style lang="scss">
    .form-sign-in {
        .forgotten-password {
            margin-top: -5px;
            text-align: right;
            margin-bottom: 15px;

            a {
                color: #8e8e8e;
                font-size: 15px;
            }
        }
    }

</style>



// WEBPACK FOOTER //
// src/core/Components/User/LostPassword.vue